<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-08-31 20:02:27
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-11 13:38:14
-->
<template>
	<div class="accountManage main-content-padding" v-loading="loading" v-if="$auth.hasPermi('system:managerUser:query')">
		<div class="pt-12 pr-24 pb-12 pl-24 yx-background-white border-radius-8">
			<BreadCrumb />
		</div>

		<div class="flex-row flex-just-start mt-16 accountPart">
			<!-- 组织架构 -->
			<div class="accountAside">
				<p class="yx-color-text-primary font-h6-medium mt-12 ml-16">公司部门</p>
				<el-tree
					:key="currentId"
					:data="depList"
					:props="defaultProps"
					ref="tree"
					node-key="id"
					@node-click="handleNodeClick"
					@current-change="activeTab"
					:current-node-key="currentId"
					:default-expanded-keys="[currentId]"
					highlight-current
					class="mt-16 font-h4-regular"
				>
					<span slot-scope="{ node, data }" class="line-ellipsis-1">
						<div class="flex-row-align-center">
							<i class="el-icon-office-building mr-8" v-if="data.parentId == 0"></i>
							<span class="tree-node-span">{{ node.label | textFormat(data.level) }}</span>
							<span class="tree-node-depnum">({{ data.deptUserNum }})</span>
						</div>
					</span>
				</el-tree>
			</div>

			<!-- 组织下的成员 -->
			<div class="accountMain ml-16" v-loading="usersLoading">
				<p class="ml-20 mt-12 font-h3-medium">{{ `${activeName}(${total})` }}</p>
				<div class="mt-24 righ-content">
					<SearchBox @getUsersList="searchUserList($event)" ref="searchBox"></SearchBox>
					<div class="ml-20">
						<el-button type="primary" @click="addAccount" plain class="mt-12 mr-16" v-auth="['system:managerUser:create']">新增账号</el-button>
						<span class="font-h4-regular">
							剩余
							<span class="yx-color-primary">{{ accountNum }}</span>
							个账号
						</span>
					</div>
					<!-- 成员列表 -->
					<multi-table
						:subtractWidth="245"
						:list="usersList"
						:total="total"
						ref="table"
						:distanceTop="35"
						:columns="columns"
						@gePartnerList="gePartnerList"
						class="ml-20 mr-24 mt-24"
					></multi-table>
				</div>
			</div>

			<!-- 新增成员抽屉 -->
			<AccountDrawer ref="accountDrawer" @refresh="refresh($event)"></AccountDrawer>

			<!-- 校验是否有已交接 -->
			<check-del ref="checkDel" @openHandover="openHandover" />

			<!-- 删除成员弹窗 -->
			<del-account ref="delAccount" @refresh="refresh" />

			<!-- 禁用启用 -->
			<deactivate ref="deactivate" @refresh="refresh" />

			<!-- 设置达人提成比 -->
			<divide ref="divide" @refresh="refresh"></divide>

			<!-- 设置招商提成比 -->
			<zs-rate-dialog ref="zsRateDialog" @refresh="refresh" />

			<!-- 重置账号抽屉 -->
			<handoverDrawer ref="handoverDrawer" @refresh="refresh" />
		</div>
	</div>
</template>

<script>
import { columns } from './columns';
import { getDeptList, getAccount, getUsersList, accountCheckDel } from '@/api/teamManage';
import SearchBox from './components/searchBox';
import AccountDrawer from './components/accountDrawer';
import throttle from 'lodash/throttle';
import divide from './components/divide';
import zsRateDialog from './components/zsRateDialog';
import { zsRoleType, drRoleType } from '@/utils/dataMap';
import handoverDrawer from './components/handoverDrawer';
import checkDel from './components/checkDel';
import delAccount from './components/delAccount';
const { checkAuth } = HOC;
export default {
	data() {
		return {
			columns,
			originData: [], //源数据
			depList: [], //源数据转换成树形的列表数据，用于el-tree
			usersList: [],
			selectNode: {},
			defaultProps: {
				children: 'children',
				label: 'name',
			},
			form: {
				deptId: '',
				nickname: '',
				mobile: '',
				roleId: '',
				status: '',
				beginTime: '',
				endTime: '',
				pageNo: 1,
				pageSize: 10,
			},
			optionColor: 'option',
			total: 0,
			loading: false,
			usersLoading: false,
			activeName: '',
			deptUserNum: 0,
			currentId: 0, //暂定
			accountNum: 0,
			delId: 0,
			params: {},
		};
	},

	components: {
		SearchBox,
		AccountDrawer,
		deactivate: () => import('./components/deactivate'),
		divide,
		zsRateDialog,
		handoverDrawer,
		checkDel,
		delAccount,
	},
	created() {
		this.getPartnerList();
	},

	methods: {
		//获取部门列表
		async getPartnerList() {
			//通过val的值来判断是否需要初始化渲染，如果val存在，则不需要初始化渲染，如果val不存在则需要初始化渲染
			this.loading = true;
			const list = await getDeptList({ all: 1 });
			this.originData = list;
			// 获取所有节点的parentId的最小值作为根节点id
			const ids = list.map(item => item.id);
			const rootId = list.find(item => !ids.includes(item.parentId))?.parentId;
			this.depList = this.arrayToTree(list, rootId, 9);
			//初始化默认选中项来渲染页面
			this.form.deptId = this.currentId = this.depList[0]?.id;
			this.activeName = this.depList[0]?.name;
			this.deptUserNum = this.depList[0]?.deptUserNum;
			await this.getAccount(); //获取剩余的账号数
			await this.getUsersList(); //获取成员列表
			this.loading = false;
		},
		//获取成员列表
		async getUsersList() {
			this.usersLoading = true;
			let params = { ...this.form, ...this.params };
			const { list, total } = await getUsersList(params);
			this.usersList = list.map(item => {
				return {
					...item,
					remark: item.remark || '-',
					//提取部门名称
					dept: item.dept.name,
					//获取按钮操作组
					operations: this.getButtons(item),
				};
			});
			this.total = total;
			this.deptUserNum = this.usersList.length;
			this.usersLoading = false;
		},
		//获取按钮操作组
		getButtons(item) {
			let arr = [];
			arr.push(
				{
					label: '编辑',
					type: 'text',
					classType: 2,
					isShow: this.$auth.hasPermi('system:managerUser:update'),
					click: row => {
						this.$refs.accountDrawer.show(2, row);
					},
				},
				{
					label: '交接',
					type: 'text',
					class: 'defalut',
					isShow: true,
					click: row => {
						this.openHandover(row);
					},
				},
				{
					label: item.status === '1' ? '禁用' : '启用',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:managerUser:update-status') && item.role.every(item => item.code != 'TENANT_ADMIN'),
					click: row => {
						this.$refs.deactivate.show(row.id, row.status);
					},
				},

				{
					label: '商务分成比',
					type: 'text',
					class: 'defalut',
					isShow: this.$auth.hasPermi('system:managerUser:percent') && item.userType.includes(drRoleType.id),
					click: row => {
						this.$refs.divide.show(row.id, row.rate, row.institutionRate);
					},
				},
				{
					label: '招商分成比',
					type: 'text',
					class: 'defalut',
					isShow: this.$auth.hasPermi('system:managerUser:percent') && item.userType.includes(zsRoleType.id),
					click: row => {
						this.$refs.zsRateDialog.show(row.id, row.partner_rate);
					},
				},
				{
					label: '删除',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:managerUser:delete') && !item.role?.some(v => v.scopeType === '1'),
					click: async row => {
						const params = { userId: row.id };
						const data = await accountCheckDel(params);
						let isCanDel = true;
						isCanDel = !data.code;
						if (data.code) return this.$refs.checkDel.show(row);
						this.$refs.delAccount.show(row.userType, isCanDel, params, data);
					},
				},
			);
			return arr.filter(item => item.isShow);
		},
		openHandover(row) {
			this.$refs.handoverDrawer.show(row);
		},
		//分页改变
		gePartnerList({ page_index, page_size }) {
			this.form.pageNo = page_index;
			this.form.pageSize = page_size;
			this.getUsersList();
		},

		//转换一维数组成树形数组
		arrayToTree(data, pid, level) {
			level--;
			return data.filter(item => item.parentId === pid).map(item => ({ ...item, children: this.arrayToTree(data, item.id, level), level: level }));
		},
		//获取剩余的账号数
		async getAccount() {
			const res = await getAccount();
			this.accountNum = res;
		},
		activeTab(node) {
			// this.loading = true;
			this.activeName = node.name;
			this.deptUserNum = node.deptUserNum;
			this.form.deptId = this.currentId = node.id;
			this.$refs.searchBox.onClear();
			this.getAccount(); //刷新剩余账号数量
			// this.loading = false;
		},
		async refresh() {
			this.getPartnerList();
		},
		addAccount: throttle(
			checkAuth(function () {
				if (this.accountNum == 0) {
					return this.$message.error('创建用户失败 (原因:超过账号最大配额)');
				}
				this.$refs.accountDrawer.show(1);
			}, 'system:managerUser:create'),
			1000,
		),
		handleNodeClick() {},
		searchUserList(params) {
			this.form.pageNo = 1;
			this.form.pageSize = 10;
			this.$refs.table.resetPage();
			this.params = params;
			this.getUsersList();
		},
	},
};
</script>
<style lang="less" scoped>
.accountManage {
	height: 100%;
	background: @color-gy2;

	.accountPart {
		height: calc(100% - 100px);

		.accountAside {
			border-radius: 2px;
			width: 228px;
			background-color: #ffffff;
			overflow: auto;
			padding-bottom: 55px;

			&::-webkit-scrollbar {
				width: 6px;
			}

			&::-webkit-scrollbar-thumb {
				height: 26px;
				border-radius: 3px;
				background-color: @border-color-lighter;
			}

			.roleName {
				height: 36px;
				width: 214px;
				margin-top: 13px;
				margin-left: 7px;
				border-radius: 4px;
			}

			.roleName + .roleName {
				margin-top: 8px;
			}
		}

		.accountMain {
			overflow-y: auto;
			-webkit-overflow-scrolling: touch;
			border-radius: 2px;
			width: calc(100% - 254px);
			background-color: #ffffff;

			&::-webkit-scrollbar {
				width: 6px;
			}

			&::-webkit-scrollbar-thumb {
				height: 26px;
				border-radius: 3px;
				background-color: @border-color-lighter;
			}
		}
	}
}

/deep/.el-tree {
	background: transparent;
	color: #4e596a;
	margin: 0 10px;

	/*改变高度*/
	.el-tree-node__content {
		height: 40px;
		margin-bottom: 8px;
	}

	/*tree组件选中背景色修改 */

	.el-tree-node > .el-tree-node__content:hover {
		background-color: #edf4ff;
		border-radius: 5px;
	}

	.el-tree-node.is-current > .el-tree-node__content {
		// background-color: #f3f2fc;
		// color: #7052ff;
		border-radius: 5px;

		.el-tree-node__expand-icon {
			// color: #7052ff;
		}
	}

	.el-tree-node__expand-icon.is-leaf {
		color: transparent !important;
	}

	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 20px;
	}
}

/deep/.el-icon-caret-right:before {
	font-size: 16px;
}

/deep/ .suffix-icon::after {
	content: '%';
	width: 33px;
	background-color: #f7f8fa;
	border-bottom-right-radius: 2px;
	border-top-right-radius: 2px;
}
</style>
